import { atom } from 'recoil'
import { LOCAL_STORAGE } from 'app-constants'

const authTokenAtom = atom<string | null>({
  key: 'authToken',
  default: localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN),
})

const anonymousAuthTokenAtom = atom<string | null>({
  key: 'anonymousAuthToken',
  default: localStorage.getItem(LOCAL_STORAGE.ANONYMOUS_AUTH_TOKEN),
})

const impersonatingAuthTokenAtom = atom<string | null>({
  key: 'impersonatingAuthToken',
  default: localStorage.getItem(LOCAL_STORAGE.IMPERSONATING_AUTH_TOKEN),
})

export { authTokenAtom, anonymousAuthTokenAtom, impersonatingAuthTokenAtom }
